import { render, staticRenderFns } from "./PostAttachments.vue?vue&type=template&id=625222c0&"
import script from "./PostAttachments.vue?vue&type=script&lang=ts&"
export * from "./PostAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports